
<div id="override" class="overrideTimeBased enable-time-based-override">
  <span class="label-time-based-override">
    <img src="{{pathVal}}icon_indicator_alert_high_16dip.png"
      class="warning-img" alt="Alert">
    </span>
    <label class="overrideDyna text" for="OverrrideDyna"><span></span>Override is controlled by Dimming Interface</label>
  </div>
  @if (column.includes('FadeTime')) {
    <div id="fadeTime" class="row slider-container-codedmains">
      <div class="col-1 signifyBookmd interface-text">Fade time</div>
      <div class="col-3 pdl-30">
        <!-- added id here -->
        <select [ngClass]="{'showingError': inputError['FadeTime']===true, 'inputCssStandard': quickConfigvalue===true}"
          [(ngModel)]="ngModelval['FadeTime']" class="signifyBookmd select-dimming"
          (change)="onChangeList($event.target.value)" id="Codedmains-fadeTime-dropdown">
          @for (currentVal of valueSet; track currentVal) {
            <option [value]="currentVal" class="info-val">
              {{ currentVal }}
            </option>
          }
        </select>
        <span class="pdl-10 codedmains-value-unit">{{fadeTimeDynamicVal}} sec</span>
      </div>
    </div>
  }

  @if (column.includes('FastFadeTime')) {
    <div id="fastFade" class="row slider-container-codedmains">
      <div class="col-1 signifyBookmd interface-text">Fast fade time</div>
      <div class="col-3 pdl-30">
        <select
          [ngClass]="{'showingError': inputError['FastFadeTime']===true, 'inputCssStandard': quickConfigvalue===true, 'disbaleStyle': isFastFadeTimeEnabled}"
          [(ngModel)]="ngModelval['FastFadeTime']" class="signifyBookmd select-dimming"
          [disabled]="isFastFadeTimeEnabled" (change)="onChangeFastFadeTimeList($event.target.value)">
          @for (value of valueSetSecond; track value) {
            <option [value]="value" class="info-val">
              {{ value }}
            </option>
          }
        </select>
        <span class="pdl-10 codedmains-value-unit">{{fastfadeTimeDynamicVal}} ms</span>
      </div>
    </div>
  }
  @if (column.includes('FallbackDetectionTime') ) {
    <div id="codedmains_FallbackDetectionTime_container"
      class="row slider-container-codedmains-new">
      <div class="col-1 label signifyBookmd text-mindim dim-margin">Fallback<br>detection time</div>
      @if (!quickConfigvalue) {
        <span class="signifyBookmd text-mindim  sliderMinValue col-1"
        >{{FallbackDetectionTimeMin}}</span>
      }
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
              <span class=" signifyBookmd minValue"> min {{ FallbackDetectionTimeMin }}</span>
            </div>
            <div class="col-2">
              <span class="signifyBookmd maxValue"> max {{ FallbackDetectionTimeMax }}</span>
            </div>
          </div>
        </div>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss">
          <ngx-slider [options]=FallbackDetectionTimeOption [(value)]=FallbackDetectionTimeValue
            (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="fallbackDetectionTimeValueChange($event.value)"
            ngDefaultControl>
          </ngx-slider>
        </div>
      }
      @if (!quickConfigvalue) {
        <span class="signifyBookmd text-mindim  col-1 maxValueCss"
        >{{FallbackDetectionTimeMax}}</span>
      }
      <div class="col-3 input-unit-wrapper">
        <input type="number" [value]="FallbackDetectionTimeDisplayValue"
          (input)="onFieldInput($event.target.value, 'FallbackDetectionTime')"
          (blur)="onFieldBlur('FallbackDetectionTime')"
          min="1" max="255"
          id="codedmains_FallbackDetectionTime_txtbox" (keypress)="numberOnly($event)"
          [ngClass]="{'showingError': inputError['FallbackDetectionTime']===true, 'inputCssStandard': quickConfigvalue===true}"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" /><span class="signifyBookmd unit-inline" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit-2']">min</span>
        </div>
      </div>
    }
    @if (column.includes('PowerOnLevel') ) {
      <div id="codedmains_PowerOnLevel_container"
        class="row slider-container-codedmains-new mb-0">
        <div class="col-1 label signifyBookmd text-mindim dim-margin">Power on level</div>
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim  sliderMinValue col-1">{{PowerOnLevelMin}}</span>
        }
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{ PowerOnLevelMin }}</span>
              </div>
              <div class="col-2">
                <span class="signifyBookmd maxValue"> max {{ PowerOnLevelMax }}</span>
              </div>
            </div>
          </div>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss">
            <ngx-slider [options]=PowerOnLevelOption [(value)]=PowerOnLevelValue (mouseup)="sliderEvent(formControl.value)"
              (userChangeEnd)="powerOnLevelOptionValueChange($event.value)" ngDefaultControl>
            </ngx-slider>
          </div>
        }
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim  col-1 maxValueCss">{{PowerOnLevelMax}}</span>
        }
        <div class="col-3 input-unit-wrapper">
          <input type="number" [value]="PowerOnLevelDisplayValue"
            (input)="onFieldInput($event.target.value, 'PowerOnLevel')"
            (blur)="onFieldBlur('PowerOnLevel')"
            id="codedmains_PowerOnLevel_txtbox"
            (keypress)="numberOnly($event)" min="0" max="100"
            [ngClass]="{'showingError': inputError['PowerOnLevel']===true, 'inputCssStandard': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" /><span class="signifyBookmd unit-inline" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit-2']">%</span>
          </div>
        </div>
      }
      <div [id]="'codedmains_PowerOnLevel_container'" class="row slider-container-codedmains-new mt-0">
        <div class="col-1 label signifyBookmd text-mindim dim-margin">Scenes</div>
      </div>
      <div id="codedmains_Scene_combined_container" class="mt-0 row slider-container-codedmains-new flexCss">
        @if (column.includes('FallbackScene')) {
          <div class="scene0-inline-row">
            <span class="scene0-label">
              <span>Scene 0</span>
              <span>fallback</span>
            </span>
            <input type="number" [(value)]="ngModelval['FallbackScene']" min="0" max="100"
              (input)="textValChanged($event.target.value, 'FallbackScene')" id="codedmains_FallbackScene_txtbox"
              (keypress)="numberOnly($event)" [disabled]="isLastDefinedDimLevelEnabled"
              [ngClass]="{'disbaleStyle': isLastDefinedDimLevelEnabled, 'showingError': inputError['FallbackScene']===true, 'inputCssStandard': quickConfigvalue===true}"
              class="scene-input scene0-input" />
              <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              <span class="scene0-text signifyBookmd">Keep last defined dim level</span>
              <input type="checkbox" id="Codedmains-dimLevelCheckBox" class="scene0-checkbox checkBoxNew" (change)="changedVal($event.target.checked)"
                [(ngModel)]="ischeckboxChecked" [checked]='ischeckboxChecked' />
              </div>
            }
            <div class="scene-row-container">
              <div class="scene-item">
                <div class="scene-label">Scene 1</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene1']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene1Id" min="0" max="100" [(ngModel)]="Scene1Value" [value]="Scene1Value" (input)="scene1ValChanged($event.target.value)"/>
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 5</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene5']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene5Id" min="0" max="100" [(ngModel)]="Scene5Value" [value]="Scene5Value" (input)="scene5ValChanged($event.target.value)" (keydown.Tab)="scene5ValChanged($event.target.value)" (mouseleave)="scene5ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 9</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene9']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene9Id" min="0" max="100" [(ngModel)]="Scene9Value" [value]="Scene9Value" (input)="scene9ValChanged($event.target.value)" (keydown.Tab)="scene9ValChanged($event.target.value)" (mouseleave)="scene9ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
            </div>
          </div>
          <div id="codedmains_Scene2_container" class="mt-0 row slider-container-codedmains-new flexCss">
            <div class="scene-row-container">
              <div class="scene-item">
                <div class="scene-label">Scene 2</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene2']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene2Id" min="0" max="100" [(ngModel)]="Scene2Value" [value]="Scene2Value" (input)="scene2ValChanged($event.target.value)" (keydown.Tab)="scene2ValChanged($event.target.value)" (mouseleave)="scene2ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 6</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene6']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene6Id" min="0" max="100" [(ngModel)]="Scene6Value" [value]="Scene6Value" (input)="scene6ValChanged($event.target.value)" (keydown.Tab)="scene6ValChanged($event.target.value)" (mouseleave)="scene6ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 10</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene10']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene10Id" min="0" max="100" [(ngModel)]="Scene10Value" [value]="Scene10Value" (input)="scene10ValChanged($event.target.value)" (keydown.Tab)="scene10ValChanged($event.target.value)" (mouseleave)="scene10ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
            </div>
          </div>
          <div id="codedmains_Scene3_container" class="mt-0 row slider-container-codedmains-new flexCss">
            <div class="scene-row-container">
              <div class="scene-item">
                <div class="scene-label">Scene 3</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene3']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene3Id" min="0" max="100" [(ngModel)]="Scene3Value" [value]="Scene3Value" (input)="scene3ValChanged($event.target.value)" (keydown.Tab)="scene3ValChanged($event.target.value)" (mouseleave)="scene3ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 7</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene7']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene7Id" min="0" max="100" [(ngModel)]="Scene7Value" [value]="Scene7Value" (input)="scene7ValChanged($event.target.value)" (keydown.Tab)="scene7ValChanged($event.target.value)" (mouseleave)="scene7ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 11</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene11']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene11Id" min="0" max="100" [(ngModel)]="Scene11Value" [value]="Scene11Value" (input)="scene11ValChanged($event.target.value)" (keydown.Tab)="scene11ValChanged($event.target.value)" (mouseleave)="scene11ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
            </div>
          </div>
          <div id="codedmains_Scene4_container" class="mt-0 row slider-container-codedmains-new flexCss">
            <div class="scene-row-container">
              <div class="scene-item">
                <div class="scene-label">Scene 4</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene4']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene4Id" min="0" max="100" [(ngModel)]="Scene4Value" [value]="Scene4Value" (input)="scene4ValChanged($event.target.value)" (keydown.Tab)="scene4ValChanged($event.target.value)" (mouseleave)="scene4ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 8</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene8']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene8Id" min="0" max="100" [(ngModel)]="Scene8Value" [value]="Scene8Value" (input)="scene8ValChanged($event.target.value)" (keydown.Tab)="scene8ValChanged($event.target.value)" (mouseleave)="scene8ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
              <div class="scene-item">
                <div class="scene-label">Scene 12</div>
                <input class="scene-input" [ngClass]="{'showingError': inputError['Scene12']===true, 'inputCssStandard': quickConfigvalue===true}" type="number" id="Scene12Id" min="0" max="100" [(ngModel)]="Scene12Value" [value]="Scene12Value" (input)="scene12ValChanged($event.target.value)" (keydown.Tab)="scene12ValChanged($event.target.value)" (mouseleave)="scene12ValChanged($event.target.value)" />
                <span class="scene-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</span>
              </div>
            </div>
          </div>
